import React from 'react';
import { Layout } from '../components/layout/Layout';
import { motion } from 'framer-motion';
import { AlertCircle } from 'lucide-react';
export function TermsConditionsPage() {
  return <Layout data-id="element-653">
      <div className="bg-gradient-to-br from-slate-50 to-teal-50 py-16" data-id="element-654">
        <div className="container mx-auto px-4 text-center" data-id="element-655">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-656">
            <h1 className="text-4xl font-bold text-slate-900 mb-4" data-id="element-657">
              Terms & Conditions
            </h1>
            <p className="text-slate-600 max-w-2xl mx-auto" data-id="element-658">
              Last updated:{' '}
              {new Date().toLocaleDateString('en-GB', {
              day: 'numeric',
              month: 'long',
              year: 'numeric'
            })}
            </p>
          </motion.div>
        </div>
      </div>

      <div className="container mx-auto px-4 py-16" data-id="element-659">
        <div className="max-w-3xl mx-auto" data-id="element-660">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-orange-50 border border-orange-200 rounded-xl p-6 mb-8 flex items-start gap-4" data-id="element-661">
            <AlertCircle className="w-6 h-6 text-orange-600 flex-shrink-0 mt-0.5" data-id="element-662" />
            <div data-id="element-663">
              <h3 className="font-semibold text-orange-900 mb-2" data-id="element-664">
                Please Read Carefully
              </h3>
              <p className="text-orange-800 text-sm leading-relaxed" data-id="element-665">
                By accessing or using HomeLinkPro, you agree to be bound by
                these Terms & Conditions. If you do not agree with any part of
                these terms, you may not use our service.
              </p>
            </div>
          </motion.div>

          <div className="prose prose-slate max-w-none" data-id="element-666">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-667">
              1. Ownership and Service
            </h2>
            <p className="text-slate-600 leading-relaxed mb-6" data-id="element-668">
              HomeLinkPro is owned and operated through the domain{' '}
              <strong data-id="element-669">homelinkpro.it.com</strong>. We provide cloud-based
              software-as-a-service (SaaS) tools designed to help businesses
              manage customer information, schedule tasks, track performance,
              share files, and collaborate in real time.
            </p>

            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-670">
              2. Description of SaaS Services
            </h2>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-671">
              HomeLinkPro provides the following services through our platform:
            </p>
            <ul className="list-disc pl-6 text-slate-600 space-y-2 mb-6" data-id="element-672">
              <li data-id="element-673">Customer management and information storage</li>
              <li data-id="element-674">Task scheduling and tracking tools</li>
              <li data-id="element-675">Real-time updates and notifications</li>
              <li data-id="element-676">Secure file sharing and document management</li>
              <li data-id="element-677">Performance monitoring and analytics</li>
              <li data-id="element-678">Team collaboration features</li>
            </ul>
            <p className="text-slate-600 leading-relaxed mb-6" data-id="element-679">
              All services are provided on a subscription basis and accessed
              through your web browser. No software installation is required.
            </p>

            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-680">
              3. Subscription and Payment Terms
            </h2>

            <h3 className="text-xl font-semibold text-slate-900 mb-3" data-id="element-681">
              3.1 Subscription Plans
            </h3>
            <p className="text-slate-600 leading-relaxed mb-6" data-id="element-682">
              We offer annual subscription plans (Silver and Gold) with
              different features and team member limits. Full details of each
              plan are available on our{' '}
              <a href="/services" className="text-teal-600 hover:text-teal-700" data-id="element-683">
                Service Details
              </a>{' '}
              page.
            </p>

            <h3 className="text-xl font-semibold text-slate-900 mb-3" data-id="element-684">
              3.2 Payment Processing
            </h3>
            <p className="text-slate-600 leading-relaxed mb-6" data-id="element-685">
              All payments are processed securely through Stripe. By
              subscribing, you authorise us to charge your payment method for
              the subscription fee. Payment is due annually on the anniversary
              of your subscription start date.
            </p>

            <h3 className="text-xl font-semibold text-slate-900 mb-3" data-id="element-686">
              3.3 Automatic Renewal
            </h3>
            <p className="text-slate-600 leading-relaxed mb-6" data-id="element-687">
              Your subscription will automatically renew each year unless you
              cancel before the renewal date. You will receive an email reminder
              before each renewal.
            </p>

            <h3 className="text-xl font-semibold text-slate-900 mb-3" data-id="element-688">
              3.4 Price Changes
            </h3>
            <p className="text-slate-600 leading-relaxed mb-6" data-id="element-689">
              We reserve the right to change our subscription prices. Any price
              changes will be communicated to you at least 30 days before they
              take effect. Existing subscribers will be notified and given the
              option to cancel before the new price applies.
            </p>

            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-690">
              4. Acceptable Use
            </h2>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-691">
              You agree to use HomeLinkPro only for lawful purposes and in
              accordance with these Terms. You must not:
            </p>
            <ul className="list-disc pl-6 text-slate-600 space-y-2 mb-6" data-id="element-692">
              <li data-id="element-693">
                Use the service to store, share, or transmit illegal, harmful,
                or offensive content
              </li>
              <li data-id="element-694">
                Attempt to gain unauthorised access to our systems or other
                users' accounts
              </li>
              <li data-id="element-695">
                Use the service to send spam, malware, or other malicious
                content
              </li>
              <li data-id="element-696">
                Reverse engineer, decompile, or attempt to extract the source
                code of our platform
              </li>
              <li data-id="element-697">
                Resell, sublicense, or share your account access with
                unauthorised parties
              </li>
              <li data-id="element-698">
                Use automated tools to scrape or extract data from the platform
              </li>
              <li data-id="element-699">Interfere with or disrupt the service or servers</li>
            </ul>
            <p className="text-slate-600 leading-relaxed mb-6" data-id="element-700">
              Violation of these terms may result in immediate suspension or
              termination of your account without refund.
            </p>

            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-701">
              5. Availability and Access
            </h2>

            <h3 className="text-xl font-semibold text-slate-900 mb-3" data-id="element-702">
              5.1 Service Availability
            </h3>
            <p className="text-slate-600 leading-relaxed mb-6" data-id="element-703">
              We strive to provide reliable access to HomeLinkPro 24/7. However,
              we do not guarantee uninterrupted access and may need to perform
              maintenance or updates that temporarily affect availability. We
              will provide advance notice of planned maintenance whenever
              possible.
            </p>

            <h3 className="text-xl font-semibold text-slate-900 mb-3" data-id="element-704">
              5.2 Access Requirements
            </h3>
            <p className="text-slate-600 leading-relaxed mb-6" data-id="element-705">
              To access HomeLinkPro, you need a compatible device, internet
              connection, and modern web browser. You are responsible for
              maintaining your internet connection and ensuring your device
              meets the minimum requirements.
            </p>

            <h3 className="text-xl font-semibold text-slate-900 mb-3" data-id="element-706">
              5.3 Account Security
            </h3>
            <p className="text-slate-600 leading-relaxed mb-6" data-id="element-707">
              You are responsible for maintaining the confidentiality of your
              account credentials and for all activities that occur under your
              account. You must notify us immediately of any unauthorised access
              or security breach.
            </p>

            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-708">
              6. Limitations of Liability
            </h2>
            <p className="text-slate-600 leading-relaxed mb-6" data-id="element-709">
              To the fullest extent permitted by law:
            </p>
            <ul className="list-disc pl-6 text-slate-600 space-y-2 mb-6" data-id="element-710">
              <li data-id="element-711">
                HomeLinkPro is provided "as is" without warranties of any kind,
                either express or implied
              </li>
              <li data-id="element-712">
                We are not liable for any indirect, incidental, or consequential
                damages arising from your use of the service
              </li>
              <li data-id="element-713">
                Our total liability to you for any claims arising from your use
                of HomeLinkPro is limited to the amount you paid for your
                subscription in the 12 months preceding the claim
              </li>
              <li data-id="element-714">
                We are not responsible for any loss of data, business
                interruption, or lost profits resulting from service outages or
                technical issues
              </li>
              <li data-id="element-715">
                We are not liable for third-party services (such as Stripe) or
                your internet connection
              </li>
            </ul>

            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-716">
              7. Data and Privacy
            </h2>
            <p className="text-slate-600 leading-relaxed mb-6" data-id="element-717">
              Your use of HomeLinkPro is also governed by our{' '}
              <a href="/privacy-cookie-policy" className="text-teal-600 hover:text-teal-700" data-id="element-718">
                Privacy & Cookie Policy
              </a>
              , which explains how we collect, use, and protect your personal
              data. By using our service, you agree to the terms of our Privacy
              & Cookie Policy.
            </p>

            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-719">
              8. Intellectual Property
            </h2>
            <p className="text-slate-600 leading-relaxed mb-6" data-id="element-720">
              All content, features, and functionality of HomeLinkPro (including
              but not limited to software, text, graphics, logos, and design)
              are owned by us and protected by UK and international copyright,
              trademark, and other intellectual property laws. You may not copy,
              modify, distribute, or create derivative works without our express
              written permission.
            </p>

            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-721">
              9. Termination
            </h2>
            <p className="text-slate-600 leading-relaxed mb-6" data-id="element-722">
              We reserve the right to suspend or terminate your account at any
              time if you violate these Terms or engage in conduct that we deem
              harmful to our service or other users. Upon termination, your
              right to access HomeLinkPro will immediately cease, and your data
              will be handled in accordance with our Privacy & Cookie Policy.
            </p>

            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-723">
              10. Dispute Resolution
            </h2>
            <p className="text-slate-600 leading-relaxed mb-6" data-id="element-724">
              If you have a dispute with HomeLinkPro, please contact us first at{' '}
              <a href="mailto:rokkaishma1@gmail.com" className="text-teal-600 hover:text-teal-700" data-id="element-725">
                rokkaishma1@gmail.com
              </a>{' '}
              to attempt to resolve the issue informally. If we cannot resolve
              the dispute through informal negotiation, any legal proceedings
              must be brought in the courts of England and Wales, and these
              Terms will be governed by the laws of England and Wales.
            </p>

            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-726">
              11. Changes to These Terms
            </h2>
            <p className="text-slate-600 leading-relaxed mb-6" data-id="element-727">
              We may update these Terms & Conditions from time to time. We will
              notify you of any significant changes by email or through a notice
              on our platform. Your continued use of HomeLinkPro after changes
              are made constitutes your acceptance of the updated Terms.
            </p>

            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-728">
              12. Contact Information
            </h2>
            <p className="text-slate-600 leading-relaxed mb-6" data-id="element-729">
              If you have any questions about these Terms & Conditions, please
              contact us:
            </p>
            <ul className="list-none pl-0 text-slate-600 space-y-2 mb-6" data-id="element-730">
              <li data-id="element-731">
                <strong data-id="element-732">Email:</strong>{' '}
                <a href="mailto:rokkaishma1@gmail.com" className="text-teal-600 hover:text-teal-700" data-id="element-733">
                  rokkaishma1@gmail.com
                </a>
              </li>
            </ul>

            <p className="text-slate-600 leading-relaxed" data-id="element-734">
              By using HomeLinkPro, you acknowledge that you have read,
              understood, and agree to be bound by these Terms & Conditions.
            </p>
          </div>
        </div>
      </div>
    </Layout>;
}